// sort an array of DOM nodes according to the HTML tree order
// http://www.w3.org/TR/html5/infrastructure.html#tree-order
function sortNodes(nodes) {
  return nodes.sort(function (a, b) {
    var posCompare = a.compareDocumentPosition(b);

    if (posCompare & 4 || posCompare & 16) {
      // a < b
      return -1;
    } else if (posCompare & 2 || posCompare & 8) {
      // a > b
      return 1;
    } else if (posCompare & 1 || posCompare & 32) {
      throw new Error('Cannot sort the given nodes.');
    } else {
      return 0;
    }
  });
}

export default sortNodes;
